// import config from "./hyjd";
import config from "./rnxrnjd";
export default Object.assign(config);